var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toggle',{attrs:{"name":_vm.name,"class-name":"form-group form-group-simple m-b-0","toggled":_vm.status},on:{"update:toggled":_vm.toggleAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }